import { useEffect } from "react";
// eslint-disable-next-line no-restricted-imports -- this module replaces useClientSideSplitTreatments usage
import { useClientSideSplitTreatments as originalUseClientSideSplitTreatments } from "@leafly-com/split-next";

import { useSplitGoogleEventPublisher } from "./useSplitGoogleEventPublisher";

export const useClientSideSplitTreatments: typeof originalUseClientSideSplitTreatments =
  (...args) => {
    const result = originalUseClientSideSplitTreatments(...args);
    const publishEvent = useSplitGoogleEventPublisher();
    const { isLoading, treatments } = result;

    useEffect(() => {
      if (isLoading) {
        return;
      }

      Object.entries(treatments).forEach(([name, treatment]) => {
        publishEvent(name, String(treatment));
      });
    }, [isLoading, treatments]);

    return result;
  };
